import React, { useEffect } from "react";
import { Alert, Badge, Button, Dropdown, Spinner } from "react-bootstrap";

export function confirmDocumentLeave(dirty) {
  return !dirty || window.confirm("Aveți modificări nesalvate. Doriți să părăsiți documentul și să le pierdeți?");
}

export default function DocumentToolbar({ title, status, isFinal = false, busy = false,
  onBack, backLabel = "Înapoi", onAdd, addLabel = "Adaugă", onSave, saveDisabled = false, onFinalize,
  closingEnabled = true, finalizeDisabled = false, canReopen = false, onReopen,
  actions = [], dirty, newDocument = false, error = "" }) {
  const menu = actions.filter(Boolean);
  const showReopen = closingEnabled && isFinal && canReopen && onReopen;
  useEffect(() => {
    if (!dirty) return;
    const warn = event => { event.preventDefault(); event.returnValue = ""; };
    window.addEventListener("beforeunload", warn);
    return () => window.removeEventListener("beforeunload", warn);
  }, [dirty]);
  const leave = action => () => {
    if (confirmDocumentLeave(dirty)) action?.();
  };
  const stateLabel = busy ? "Se procesează…" : error ? "Eroare" : dirty ? "Modificări nesalvate" : newDocument ? "Document nou" : "Salvat";
  const stateColor = busy ? "secondary" : error ? "danger" : dirty ? "warning" : newDocument ? "info" : "success";
  return <div className="mb-3 document-toolbar">
    <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
      <h3 className="mb-0">{title}</h3>
      <span role="status" aria-live="polite">{isFinal ? <Badge bg="secondary">Finalizat</Badge> : dirty !== undefined ? <Badge bg={stateColor}>{stateLabel}</Badge> : status}</span>
    </div>
    <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 d-print-none">
      <div className="d-flex flex-wrap align-items-center gap-2">
        <Button type="button" variant="outline-secondary" disabled={busy} onClick={leave(onBack)}>← {backLabel}</Button>
        {onAdd && <Button type="button" variant="outline-primary" disabled={busy} onClick={leave(onAdd)}>{addLabel}</Button>}
      </div>
      <div className="d-flex flex-wrap align-items-center gap-2">
        {(menu.length > 0 || showReopen) && <Dropdown>
          <Dropdown.Toggle variant="outline-secondary" disabled={busy}>Acțiuni</Dropdown.Toggle>
          <Dropdown.Menu align="end">
            {menu.map((action) => <Dropdown.Item key={action.label} disabled={action.disabled} onClick={action.leavesDocument ? leave(action.onClick) : action.onClick}>{action.label}</Dropdown.Item>)}
            {showReopen && <>
              {menu.length > 0 && <Dropdown.Divider />}
              <Dropdown.Item onClick={onReopen}>Redeschide</Dropdown.Item>
            </>}
          </Dropdown.Menu>
        </Dropdown>}
        {!isFinal && onSave && <Button type="button" variant="primary" disabled={busy || saveDisabled} onClick={onSave}>
          {busy && <Spinner size="sm" className="me-2" />}Salvează
        </Button>}
        {!isFinal && closingEnabled && onFinalize && <span title={finalizeDisabled ? "Salvează modificările înainte de finalizare." : "Blochează documentul la modificare și ștergere."}>
          <Button type="button" variant="success" disabled={busy || finalizeDisabled} onClick={onFinalize}>Finalizează</Button>
        </span>}
      </div>
    </div>
    {dirty !== undefined && isFinal && <Alert variant="secondary" className="mt-3 mb-0">
      Document finalizat. Datele pot fi consultate, dar nu pot fi modificate.
      {showReopen && <> Pentru modificări, folosiți <strong>Acțiuni → Redeschide</strong>.</>}
    </Alert>}
  </div>;
}
